import React from "react";
import { cn } from "lib/utils";
import "./globals.css";
import "./app-styles.css";

export function Container({ className, children, ...props }) {
  return (
    <div className={cn("ls-container", className)} {...props}>
      {children}
    </div>
  );
}

export function AppWrapper({ className, children, isRTL, dir, ...props }) {
  return (
    <div
      dir={dir || (isRTL ? "rtl" : "ltr")}
      className={cn("ls-app-wrapper", isRTL && "ls-rtl", className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function ConcentWrapper({ className, children, ...props }) {
  return (
    <div className={cn("ls-concent-wrapper", className)} {...props}>
      {children}
    </div>
  );
}

export function ExampleNoticeWrapper({ className, children, ...props }) {
  return (
    <div className={cn("ls-example-notice-wrapper", className)} {...props}>
      {children}
    </div>
  );
}
